/**
 * PI Judgme Testimonials – custom element
 * Watches Judgeme app’s .jdgm-videos-container for dynamically loaded cards,
 * copies content into .pi-judgme-card slides and (re)inits Swiper.
 * Judgeme header is hidden (heading comes from section only).
 */
(function () {
  const VERIFIED_SVG =
    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" class="pi-jdgm-verified-icon"><path d="M8.9375 10.875L7.6875 9.64583C7.53472 9.49306 7.36111 9.41667 7.16667 9.41667C6.97222 9.41667 6.79861 9.49306 6.64583 9.64583C6.49306 9.79861 6.41667 9.97569 6.41667 10.1771C6.41667 10.3785 6.49306 10.5556 6.64583 10.7083L8.41667 12.4792C8.56944 12.6319 8.74306 12.7083 8.9375 12.7083C9.13194 12.7083 9.30556 12.6319 9.45833 12.4792L13.3542 8.58333C13.5069 8.43056 13.5833 8.25347 13.5833 8.05208C13.5833 7.85069 13.5069 7.67361 13.3542 7.52083C13.2014 7.36806 13.0278 7.29167 12.8333 7.29167C12.6389 7.29167 12.4653 7.36806 12.3125 7.52083L8.9375 10.875ZM10 18C8.90278 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0764 2.625 13.1042C2.20833 12.1319 2 11.0972 2 10C2 8.88889 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92361 3.04167 6.89583 2.625C7.86806 2.20833 8.90278 2 10 2C11.1111 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6562 4.34375C16.3854 5.07292 16.9583 5.92014 17.375 6.88542C17.7917 7.85069 18 8.88889 18 10C18 11.0972 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6562 15.6562C14.9271 16.3854 14.0799 16.9583 13.1146 17.375C12.1493 17.7917 11.1111 18 10 18Z"></path></svg>';

  /** @param {Element} cardEl */
  function getStarColor(cardEl) {
    const star = cardEl.querySelector('.jdgm-rating-section .jdgm-star.jdgm--on');
    if (!star) return 'rgb(231, 161, 174)';
    const color = /** @type {HTMLElement} */ (star).style.color;
    return color || 'rgb(231, 161, 174)';
  }

  /** @param {number} count @param {string} color */
  function getStarsHtml(count, color) {
    const c = Math.min(5, Math.max(0, Number(count) || 5));
    let html = '<div class="pi-jdgm-stars">';
    for (let i = 0; i < 5; i++) {
      const on = i < c ? ' jdgm--on' : '';
      html += `<span class="pi-jdgm-star jdgm-star${on}" style="color: ${color};"></span>`;
    }
    html += '</div>';
    return html;
  }

  /**
   * @param {Element} jdgmCard - .jdgm-card / .jdgm-media-card
   * @returns {boolean} - true if this is a real card (not a clone)
   */
  /** @param {Element} jdgmCard */
  function isRealCard(jdgmCard) {
    if (/** @type {HTMLElement} */ (jdgmCard).dataset?.cloneType) return false;
    if (jdgmCard.classList.contains('jdgm-clone-before') || jdgmCard.classList.contains('jdgm-clone-after')) return false;
    return true;
  }

  /**
   * Extract content from a Judgeme card and return data for .pi-judgme-card
   */
  /** @param {Element} jdgmCard */
  function extractCardData(jdgmCard) {
    const imgEl = jdgmCard.querySelector('img');
    const imgSrc = imgEl ? (imgEl.getAttribute('src') || '') : '';
    const imgAlt = imgEl ? (imgEl.getAttribute('alt') || '') : '';
    const textEl = jdgmCard.querySelector('.jdgm-text p');
    const text = textEl ? textEl.innerHTML.trim() : '';
    const starsEl = jdgmCard.querySelector('.jdgm-rating-section .jdgm-stars');
    const starCount = starsEl ? starsEl.querySelectorAll('.jdgm-star.jdgm--on').length : 5;
    const starColor = getStarColor(jdgmCard);
    const nameEl = jdgmCard.querySelector('.jdgm-reviewer-name');
    const reviewerName = nameEl ? nameEl.textContent.trim() : '';
    const productLinkEl = jdgmCard.querySelector('.jdgm-product-name a');
    const productHref = productLinkEl ? (productLinkEl.getAttribute('href') || '') : '';
    const productText = productLinkEl ? productLinkEl.textContent.trim() : '';
    const hasVerified = !!jdgmCard.querySelector('.jdgm-reviewer-verified-icon');
    return { imgSrc, imgAlt, text, starCount, starColor, reviewerName, productHref, productText, hasVerified };
  }
function optimizeImgixUrl(src, width) {
    if (!src) return src;
    try {
      const url = new URL(src);
      url.searchParams.set('w', width);
      url.searchParams.set('auto', 'format,compress');
      url.searchParams.set('q', '70');
      return url.toString();
    } catch(e) { return src; }
  }

  /** @param {{ imgSrc: string, imgAlt: string, text: string, starCount: number, starColor: string, reviewerName: string, productHref: string, productText: string, hasVerified: boolean }} data */
  function buildPiCardHtml(data) {
    const imgHtml =
      data.imgSrc
        ? `<div class="pi-jdgm-media"><img 
            src="${escapeHtml(optimizeImgixUrl(data.imgSrc, 600))}"
            srcset="${escapeHtml(optimizeImgixUrl(data.imgSrc, 400))} 400w, ${escapeHtml(optimizeImgixUrl(data.imgSrc, 600))} 600w, ${escapeHtml(optimizeImgixUrl(data.imgSrc, 900))} 900w"
            sizes="(max-width: 768px) 60vw, 40vw"
            alt="${escapeHtml(data.imgAlt)}" 
            loading="lazy"></div>`
        : '';
    const starsHtml = getStarsHtml(data.starCount, data.starColor);
    const verifiedHtml = data.hasVerified ? `<span class="pi-jdgm-reviewer-verified">${VERIFIED_SVG}</span>` : '';
    const productHtml =
      data.productHref && data.productText
        ? `<div class="pi-jdgm-product-name"><a class="pi-jdgm-product-name__link" href="${escapeHtml(data.productHref)}" target="_blank" rel="noopener noreferrer">${escapeHtml(data.productText)}</a></div>`
        : '';
    const textBlock =
      '<div class="pi-jdgm-text"><p class="pi-jdgm-text__body">' + (data.text || '') + '</p></div>' +
      '<div class="pi-jdgm-rating-section">' +
      starsHtml +
      '<div class="pi-jdgm-reviewer-info">' +
      '<span class="pi-jdgm-reviewer-name">' + escapeHtml(data.reviewerName) + '</span>' +
      verifiedHtml +
      '</div>' +
      productHtml +
      '</div>';
    return '<div class="pi-judgme-card">' + imgHtml + '<div class="pi-jdgm-content">' + textBlock + '</div></div>';
  }

  /** @param {string} str */
  function escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  class PiJudgmeTestimonials extends HTMLElement {
    constructor() {
      super();
      this._containerObserver = null;
      this._bodyObserver = null;
      this._swiperInstance = null;
      this._syncScheduled = null;
      /** @type {Element | null} */
      this._jdgmContainer = null;
    }

    connectedCallback() {
      this._wrapper = this.querySelector('.pi-judgme-swiper .swiper-wrapper');
      this._swiperEl = this.querySelector('.pi-judgme-swiper');
      if (!this._wrapper || !this._swiperEl) return;

      this._waitForJdgmContainer();
    }

    disconnectedCallback() {
      this._bodyObserver?.disconnect();
      this._bodyObserver = null;
      this._containerObserver?.disconnect();
      this._containerObserver = null;
      this._destroySwiper();
      if (this._syncScheduled) {
        clearTimeout(this._syncScheduled);
        this._syncScheduled = null;
      }
    }

    _waitForJdgmContainer() {
      const container = document.querySelector('.jdgm-videos-container');
      if (container) {
        this._onJdgmContainerFound(container);
        return;
      }
      this._bodyObserver = new MutationObserver(() => {
        const c = document.querySelector('.jdgm-videos-container');
        if (c && c !== this._jdgmContainer) {
          this._onJdgmContainerFound(c);
        }
      });
      this._bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    /** @param {Element} container */
    _onJdgmContainerFound(container) {
      if (this._jdgmContainer === container) return;
      this._bodyObserver?.disconnect();
      this._bodyObserver = null;
      this._jdgmContainer = container;

      this._hideJdgmHeader();
      this._scheduleSync();
      this._containerObserver = new MutationObserver(() => this._scheduleSync());
      this._containerObserver.observe(container, { childList: true, subtree: true });
    }

    _hideJdgmHeader() {
      const carousel = this._jdgmContainer?.closest('.jdgm-videos-carousel, .jdgm-cards-carousel, .jdgm-testimonials-carousel');
      if (!carousel) return;
      const header = carousel.querySelector('.jdgm-header');
      if (header) /** @type {HTMLElement} */ (header).style.setProperty('display', 'none', 'important');
      /* Hide Judgeme carousel UI so only our swiper + section heading show */
      const wrapper = carousel.querySelector('.jdgm-videos-wrapper, .jdgm-cards-wrapper');
      if (wrapper) /** @type {HTMLElement} */ (wrapper).style.setProperty('display', 'none', 'important');
    }

    _scheduleSync() {
      if (this._syncScheduled) return;
      this._syncScheduled = setTimeout(() => {
        this._syncScheduled = null;
        this._syncCards();
      }, 150);
    }

    _syncCards() {
      if (!this._jdgmContainer || !this._wrapper) return;

      const cards = Array.from(this._jdgmContainer.querySelectorAll('.jdgm-card, .jdgm-media-card.jdgm-carousel-item')).filter(
        isRealCard
      );
      if (cards.length === 0) return;

      const fragment = document.createDocumentFragment();
      cards.forEach((jdgmCard) => {
        const data = extractCardData(jdgmCard);
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = buildPiCardHtml(data);
        fragment.appendChild(slide);
      });

      this._wrapper.innerHTML = '';
      this._wrapper.appendChild(fragment);
      this._destroySwiper();
      this._initSwiper();
    }

    _destroySwiper() {
      if (this._swiperInstance) {
        this._swiperInstance.destroy(true, true);
        this._swiperInstance = null;
      }
    }

    _initSwiper() {
      if (!this._swiperEl) return;
      const win = /** @type {unknown} */ (typeof window !== 'undefined' ? window : null);
      const SwiperClass = win && typeof win === 'object' && /** @type {Record<string, unknown>} */ (win)['Swiper'];
      if (typeof SwiperClass !== 'function') return;
      const next = this.querySelector('.swiper-button-next');
      const prev = this.querySelector('.swiper-button-prev');
      const pagination = this.querySelector('.swiper-pagination');
      this._swiperInstance = new /** @type {new (el: HTMLElement, options: object) => { destroy: (a?: boolean, b?: boolean) => void }} */ (SwiperClass)(/** @type {HTMLElement} */ (this._swiperEl), {
        speed: 800,
        slidesPerView: 1.2,
        spaceBetween: 30,
        centeredSlides: false,
        autoHeight: true,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          1024: { slidesPerView: 1.15 },
          768: { slidesPerView: 1 },
          480: { slidesPerView: 1 },
          400: { slidesPerView: 1 },
          350: { slidesPerView: 1 },
          320: { slidesPerView: 1 },
        },
      });
    }
  }

  if (!customElements.get('pi-judgme-testimonials')) {
    customElements.define('pi-judgme-testimonials', PiJudgmeTestimonials);
  }
})();
